import { AxiosError } from 'axios';
import { Button, Stack } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { IFormPhoneValidationReq } from '../../../commons/interfaces/form-response.interface';
import Paper from '../../../components/Paper';
import PublicFormInput from '../../../components/PublicFormInput';
import usePublicForm from '../../../hooks/publicForm.hook';
import PublicService from '../../../services/public.service';

const publicService = new PublicService();

const ValidateForm = () => {
  const {
    handleSubmit,
    register,
    formState: { errors }
  } = useForm<IFormPhoneValidationReq>({ criteriaMode: 'all' });
  const { setStep, setCustomer } = usePublicForm();

  const onSubmit = async (data: IFormPhoneValidationReq) => {
    try {
      const phoneNumber = '51' + data.phoneNumber;
      const response = await publicService.validateCustomerPhone({ phoneNumber });
      setCustomer(response.data);
      setStep(3);
    } catch (err: unknown) {
      if (err instanceof AxiosError) {
        const { response } = err;
        if (response?.data.code === 404) {
          setStep(2);
        }
      }
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} noValidate>
      <Stack gap={3}>
        <Paper className="form-title">
          <div className="mb-2">
            <span className="text-title">Validación de cliente</span>
          </div>
          <div>
            <p>Con el fin de poder validar por favor introduzca los datos que se solicitan.</p>
          </div>
        </Paper>
        <PublicFormInput
          register={register}
          questionId="phoneNumber"
          question="Ingrese su número celular"
          type="TEXT"
          errors={errors}
        />
        <div className="form-footer">
          <Button variant="primary" type="submit">
            Validar
          </Button>
        </div>
      </Stack>
    </form>
  );
};

export default ValidateForm;
